import { Component } from "react";
import { text } from "@quickpoint.me/shared";
import stepSizes from "./stepSizes";
import { withTour } from "@reactour/tour";

//  [...intro, ...basics(hostId), ...stories, ...images(hostId), ...split, ...grid];

class Contents extends Component {
	render() {
		const handleClick = (
			location:
				| "basics"
				| "stories"
				| "formatting"
				| "links"
				| "images"
				| "charts"
				| "publishing"
				| "split"
				| "grid"
				| "fx",
		) => {
			let step = 0;
			switch (location) {
				case "basics":
					step = stepSizes().intro;
					break;
				case "stories":
					step = stepSizes().intro + stepSizes().basics;
					break;
				case "formatting":
					step = stepSizes().intro + stepSizes().basics + stepSizes().stories;

					break;
				case "links":
					step =
						stepSizes().intro +
						stepSizes().basics +
						stepSizes().stories +
						stepSizes().formatting;
					break;
				case "images":
					step =
						stepSizes().intro +
						stepSizes().basics +
						stepSizes().stories +
						stepSizes().formatting +
						stepSizes().links;
					break;
				case "charts":
					step =
						stepSizes().intro +
						stepSizes().basics +
						stepSizes().stories +
						stepSizes().formatting +
						stepSizes().links +
						stepSizes().images;
					break;
				case "publishing":
					step =
						stepSizes().intro +
						stepSizes().basics +
						stepSizes().stories +
						stepSizes().formatting +
						stepSizes().links +
						stepSizes().images +
						stepSizes().charts;
					break;
				case "split":
					step =
						stepSizes().intro +
						stepSizes().basics +
						stepSizes().stories +
						stepSizes().formatting +
						stepSizes().links +
						stepSizes().images +
						stepSizes().charts +
						stepSizes().publishing;
					break;
				case "grid":
					step =
						stepSizes().intro +
						stepSizes().basics +
						stepSizes().stories +
						stepSizes().formatting +
						stepSizes().links +
						stepSizes().images +
						stepSizes().charts +
						stepSizes().publishing +
						stepSizes().split;
					break;
				case "fx":
					step =
						stepSizes().intro +
						stepSizes().basics +
						stepSizes().stories + // was missing — fx jumped one section short
						stepSizes().formatting +
						stepSizes().links +
						stepSizes().images +
						stepSizes().charts +
						stepSizes().publishing +
						stepSizes().split +
						stepSizes().grid;
					break;
				default:
					step = 0;
			}
			// @ts-expect-error
			this.props.setCurrentStep(step);
		};
		return (
			<>
				<div>
					{text.tourSteps.contentsInstructions}
				</div>
				<button
					className="tour-step-links"
					onClick={() => handleClick("basics")}
					type="button"
				>
					{text.tourSteps.contentsGettingStarted}
				</button>
				<button
					className="tour-step-stories"
					onClick={() => handleClick("stories")}
					type="button"
				>
					{text.tourSteps.contentsStories}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("formatting")}
					type="button"
				>
					{text.tourSteps.contentsFormattingText}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("links")}
					type="button"
				>
					{text.tourSteps.contentsLinksAndBacklinks}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("images")}
					type="button"
				>
					{text.tourSteps.contentsAddingImages}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("charts")}
					type="button"
				>
					{text.tourSteps.contentsCharts}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("publishing")}
					type="button"
				>
					{text.tourSteps.contentsSharingAndPublishing}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("split")}
					type="button"
				>
					{text.tourSteps.contentsMasteringLayouts}
				</button>
				<button
					className="tour-step-links"
					onClick={() => handleClick("fx")}
					type="button"
				>
					{text.tourSteps.contentsMasteringFx}
				</button>
			</>
		);
	}
}

export default withTour(Contents);
